import { SelfDebug } from "./main/self-debug.js";
import { Connection } from "./main/connection.js";
import { Editor } from "./main/editor.js";
export default function mirrorsharp(textarea, options) {
  const selfDebug = options.selfDebugEnabled ? new SelfDebug() : null;
  const connection = new Connection(options.serviceUrl, selfDebug, {
    delayedOpen: options.noInitialConnection
  });
  const editor = new Editor(textarea, connection, selfDebug, options);
  let connectCalled = false;
  return Object.freeze({
    getCodeMirror: () => editor.getCodeMirror(),
    setText: text => editor.setText(text),
    getLanguage: () => editor.getLanguage(),
    setLanguage: value => editor.setLanguage(value),
    setServerOptions: value => editor.setServerOptions(value),
    connect: () => {
      if (!options.noInitialConnection) throw new Error('Connect can only be called if options.noInitialConnection was set.');
      if (connectCalled) throw new Error('Connect can only be called once per mirrorsharp instance (on start).');
      connection.open();
      connectCalled = true;
    },

    destroy(destroyOptions) {
      editor.destroy(destroyOptions);
      connection.close();
    }

  });
}